import React from 'react'
import OppBriefSection from "./OppBriefSection";
import { Link } from 'react-router-dom';

import TeamMemberCard from './TeamMemberCard';

export default class OppBriefTeamMembersSection extends OppBriefSection {

    static sectionTitle = 'Team Members';

    static TranslationKey = 'start_project.contract_team_members';

    static CompletedField = 'accepted_team_at';

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,

        }
    }

    componentDidMount() {
        super.componentDidMount();

        // console.log('componentDidMount', this.props.opportunity)
    }


    renderServiceTeam(project) {
        if (!this.props.opportunity.team) {
            return (
                <div className="project-members-overview project-brief-section pb-4">
                    <div className="deliverable-category-container client-project-overview">
                        <div className="deliverable-panel">
                            <p className="deliverable-title">Team Project Type & Background</p>

                            <div className="deliverable-details-panel">
                                <div className="deliverable-section">
                                    <p className="deliverable-section-title">Project Type</p>

                                    <div className="deliverable-section-description flex gap-4">
                                        <p className="brief-members-team-title">{project.service.name}</p>
                                    </div>
                                </div>
                                <div className="deliverable-section">
                                    <p className="deliverable-section-title">Description</p>

                                    <p className="deliverable-section-description">
                                        {project.service.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="deliverable-panel">
                            <p className="deliverable-title">Team Member Roles</p>

                            <div className="deliverable-details-panel">
                                {project.disciplines?.length > 0 && (
                                    <div className="flex flex-col gap-4">
                                        {project.disciplines.map((dis, i) => (
                                            <div key={`dis${dis.id}`} className="flex flex-col gap-2">
                                                <p className="font-semibold text-primary text-base">{dis.name}</p>
                                                <p className="text-xs">{dis.description}</p>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        let team = this.props.opportunity.team,
            members = this.props.opportunity.teamMembers();

        return (
            <div className="project-members-overview project-brief-section pb-4">
                <div className="deliverable-category-container client-project-overview">
                    <div className="deliverable-panel">
                        <p className="deliverable-title">Team Name & Background</p>

                        <div className="deliverable-details-panel">
                            <div className="deliverable-section">
                                <p className="deliverable-section-title">Name</p>

                                <div className="deliverable-section-description flex gap-4">
                                    <p className="brief-members-team-title">{team.name}</p>
                                    <Link to={`/team-profiles/${team.id}`} target="_blank" className="btn btn-link-primary py-0">View team</Link>
                                </div>
                            </div>
                            <div className="deliverable-section">
                                <p className="deliverable-section-title">About</p>

                                <p className="deliverable-section-description">
                                    {team.bio}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="deliverable-panel">
                        <p className="deliverable-title">Team Members & Roles</p>

                        <div className="deliverable-details-panel">
                            {members.length > 0 && (
                                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 text-center">
                                    {members.map((member, i) => (
                                        <div key={`member${i}`} className="w-full brief-member">
                                            <TeamMemberCard member={member} teamId={team.id} />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { opportunity } = this.props;
        if (!opportunity.project) {
            return <div />
        }

        if (opportunity.project.isService()) {
            return this.renderServiceTeam(opportunity.project);
        }

        return <div />;
    }
}